function rgbaToHexA(rgba) {
    const result = /^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+(\.\d+)?)[\s+]?/i.exec(rgba);
    return (result && result.length >= 4)
        ? {
            hex: (`#${(`0${parseInt(result[1], 10).toString(16)}`).slice(-2)}${(`0${parseInt(result[2], 10).toString(16)}`).slice(-2)}${(`0${parseInt(result[3], 10).toString(16)}`).slice(-2)}`).toUpperCase(),
            alpha: +result[4],
        }
        : {
            hex: rgba,
            alpha: 1,
        };
}
function rgbToHex(rgb) {
    const result = /^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?[\s+]?/i.exec(rgb);
    return (result && result.length >= 4)
        ? (`#${(`0${parseInt(result[1], 10).toString(16)}`).slice(-2)}${(`0${parseInt(result[2], 10).toString(16)}`).slice(-2)}${(`0${parseInt(result[3], 10).toString(16)}`).slice(-2)}`).toUpperCase()
        : rgb;
}

export { rgbToHex, rgbaToHexA };
//# sourceMappingURL=color-change.js.map
